import { Skeleton } from '@components/ui/skeleton';
import CollectionCard from '@components/common/collection-card';
import { useMainIconsQuery } from '@framework/content/get-main-icons';
interface Props {
  //   data: any;
  className?: string;
  variant?: 'default' | 'modern';
}
const MainIconBlock: React.FC<Props> = ({
  className = 'mb-12 md:mb-14 xl:mb-16 lg:pt-1 xl:pt-0',
  variant = 'default'
}) => {
  const {
    data,
    isLoading,
    error,
    status
  } = useMainIconsQuery({
    limit: 3
  });
  const isEven = (value: number) => {
    return value % 2;
  };
  if (isLoading || error || data?.length === 0 || status !== 'success') {
    return <div className={`${className} grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 xl:gap-7`}>
        {[1, 2, 3].map((_, i) => <div key={i} className="flex flex-col justify-between overflow-hidden rounded-md pb-4 sm:pb-0">
            {i === 1 ? <>
                <div className="px-4 sm:px-0 pt-4 text-center">
                  <Skeleton className="h-6 w-3/4 mb-2 mx-auto rounded" />
                  <Skeleton className="h-4 w-full max-w-[90%] mx-auto rounded" />
                </div>
                <Skeleton className="w-[600px] h-[600px] mx-auto mt-4 rounded-md" />
              </> : <>
                <Skeleton className="w-[600px] h-[600px] mx-auto mb-4 rounded-md" />
                <div className="px-4 sm:px-0 text-center">
                  <Skeleton className="h-6 w-3/4 mb-2 mx-auto rounded" />
                  <Skeleton className="h-4 w-full max-w-[90%] mx-auto rounded" />
                </div>
              </>}
          </div>)}
      </div>;
  }
  return <div className={`${className} grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 xl:gap-7`} data-sentry-component="MainIconBlock" data-sentry-source-file="main-icons.tsx">
      {data?.slice(0, 3)?.map((item: any, index: any) => <CollectionCard key={index} collection={item} variant={variant} contactClassName={isEven(index + 1) == 0 && variant !== 'modern' ? 'sm:pb-4 md:pb-5 lg:pb-4 2xl:pb-5 3xl:pb-6 pt-3.5 sm:pt-0.5 lg:pt-1 px-4 sm:px-0' : 'pt-3.5 lg:pt-4 xl:pt-5 3xl:pt-7 px-4 sm:px-0'} />)}
    </div>;
};
export default MainIconBlock;